import React, { useState } from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, elevation, formatMoney } from '../tokens';

const UpgradeAskBanner = ({
  currentAmount,
  suggestedAmount,
  streak,
  onSend,
  onDismiss,
  visible = true,
}) => {
  const [localVisible, setLocalVisible] = useState(true);
  if (!visible || !localVisible || !currentAmount) return null;

  const suggest = suggestedAmount || Math.round(currentAmount * 1.4 / 5) * 5;
  const bump = formatMoney(suggest - currentAmount);

  const handleDismiss = () => {
    setLocalVisible(false);
    onDismiss && onDismiss();
  };

  return (
    <div style={{
      display: 'flex',
      gap: space[3],
      alignItems: 'center',
      padding: `${space[3]}px ${space[4]}px`,
      background: 'linear-gradient(90deg, #fff8e1 0%, #fef3d1 100%)',
      border: `1px solid ${colors.warning}`,
      borderRadius: radius.md,
      boxShadow: elevation.card,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: '50%',
        background: colors.warning,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Icon category="utility" name="trending" size="small" style={{ fill: '#fff' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ ...type.body, color: colors.textPrimary, fontWeight: 700 }}>
          ✨ {streak} consecutive on-time payments — time to ask for an increase?
        </div>
        <div style={{ ...type.small, color: colors.textSecondary, marginTop: 2 }}>
          Suggest upgrading {formatMoney(currentAmount)}/mo → <strong>{formatMoney(suggest)}/mo</strong>{' '}
          <span style={{ color: colors.success }}>(+{bump}/mo)</span>.
          Recurring donors who accept an upgrade after 12 on-time gifts stick around 2.4× longer.
        </div>
      </div>
      <button
        onClick={() => onSend && onSend(suggest)}
        style={{
          padding: `${space[2]}px ${space[4]}px`,
          background: colors.brand,
          color: '#fff',
          border: 'none',
          borderRadius: radius.sm,
          ...type.small,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Send upgrade ask
      </button>
      <button
        onClick={handleDismiss}
        title="Dismiss"
        style={{
          padding: space[1],
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: radius.sm,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon category="utility" name="close" size="x-small" style={{ fill: colors.textSecondary }} />
      </button>
    </div>
  );
};

export default UpgradeAskBanner;
